const PendingModuleEnrolmentColumn = [
    {
        header: "PA Name",
        accessor: "pa",
        width: 400,
    },
    {
        header: "Program Name",
        accessor: "program",
        width: 400,
    },
    {
        header: "Module Name",
        accessor: "module",
        width: 400,
    },
    {
        header: "Start Date",
        accessor: "start_date",
        width: 200,
    },
    {
        header: "End Date",
        accessor: "end_date",
        width: 200,
    }
]

const PendingAttendanceColumn = [
    {
        header: "PA Name",
        accessor: "pa",
        width: 400,
    },
    {
        header: "Program Name",
        accessor: "program",
        width: 400,
    },
    {
        header: "Module Name",
        accessor: "module",
        width: 400,
    },
    {
        header: "Session",
        accessor: "session",
        width: 200,
    },
    {
        header: "Session Date",
        accessor: "session_date",
        width: 200,
    },
    {
        header: "Start Time",
        accessor: "start_time",
        width: 200,
    },
    {
        header: "End Time",
        accessor: "end_date",
        width: 200,
    }

]

const PendingAssessmentColumn = [
    {
        header: "PA Name",
        accessor: "pa",
        width: 400,
    },
    {
        header: "Program Name",
        accessor: "program",
        width: 400,
    },
    {
        header: "Module Name",
        accessor: "module",
        width: 400,
    },
    {
        header: "Start Date",
        accessor: "start_date",
        width: 200,
    },
    {
        header: "End Date",
        accessor: "end_date",
        width: 200,
    }
]


export {
    PendingModuleEnrolmentColumn,
    PendingAttendanceColumn,
    PendingAssessmentColumn
}